const parseTestMarkets = () => (process.env.REACT_APP_COUNTRY_CODE_TEST_MARKET || "")
    .split(",")
    .map((code) => code.trim().toUpperCase())
    .filter(Boolean);
// Temporarily disabled — testmarket flow deactivated due to race condition
// where sessionStorage("country") is set asynchronously by the theme after
// the React extension has already initialized with fallback "US".
// To re-enable, remove the early return below.
export const isTestMarketCountry = (country) => {
    return false;
    // Original logic preserved for re-activation:
    // if (!country) return false;
    // const normalizedCountry = (country ?? "").toString().trim().toUpperCase();
    // return parseTestMarkets().includes(normalizedCountry);
};
export const getTestMarketCountries = () => parseTestMarkets();
